/**
 * Wrapper function for HTMLElement.querySelector
 * @param string selector
 * @param null || HTMLElement parent
 * @returns The first element inside parent (document, if omitted), that matches the selector
 */
const $ = (selector: string, parent: HTMLElement | Document = document): HTMLElement | null => parent.querySelector(selector)

/**
 * Wrapper function for HTMLElement.querySelectorAll
 * @param string selector
 * @param null || HTMLElement parent
 * @returns All the elements inside parent (document, if omitted), that match the selector, spread into an array
 */
const $$ = (selector: string, parent: HTMLElement | Document = document): Array<HTMLElement> => [...parent.querySelectorAll(selector)] as Array<HTMLElement>

export {$, $$};
